import { useEffect } from "react";
import "../css/download.css";
import { CreateCode } from "./reference";
import merlinDBModule from '../../node_modules/@chrisaxxwell/merlin-db/package.json';
import Head from "./head";

export default function Download() {

   useEffect(() => {
      window.scrollTo(0, 0);

   }, []);

   return (
      <main id="download">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "Download Page - MerlinDB",
            description: "Download the tool to improve your productivity. Quick and safe installation.",
            page_author: "Chris Axxwell",
            index: "index, follow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados, download, npm, tool",
            canonical: "/download",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />
         <h1>Downloads</h1>
         <div>
            <h3>Latest release</h3>
            <a download href="https://raw.githubusercontent.com/chrisaxxwell/merlin-db/main/dist/merlindb.min.js" rel="referrer">Download version {merlinDBModule.version}</a>
            <p>Released on {merlinDBModule.lastUpdated}</p>
            <span></span>
         </div>
         <h4>Or using the <strong className="schema4">npm</strong> command line</h4>

         <code >
            <CreateCode content={`
npm install @chrisaxxwell/merlin-db;
import MerlinDB from "@chrisaxxwell/merlin-db";
      `} />
         </code>
      </main >
   )
} 